import React, {
  ReactNode,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Box, Button, makeStyles, Popover } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  popoverContainer: {
    padding: theme.spacing(2),
  },
}));

interface FilterButtonProps {
  buttonLabel?: string;
  buttonClassName?: string;
  popoverContent: ReactNode;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  disabled?: boolean;
}

export interface FilterButtonRef {
  close: () => void;
}

export const FilterButton = forwardRef<FilterButtonRef, FilterButtonProps>(
  (
    {
      buttonLabel,
      buttonClassName,
      popoverContent,
      startIcon,
      endIcon,
      disabled
    },
    ref
  ) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    useImperativeHandle(ref, () => ({
      close: handleClose,
    }));

    const open = Boolean(anchorEl);
    const id = `filter-popover-${buttonLabel}`;

    return (
      <>
        <Button
          startIcon={startIcon}
          endIcon={endIcon}
          color="primary"
          variant="outlined"
          className={buttonClassName}
          onClick={handleClick}
          disabled={disabled}
        >
          {buttonLabel}
        </Button>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Box className={classes.popoverContainer}>{popoverContent}</Box>
        </Popover>
      </>
    );
  }
);
